import { render, staticRenderFns } from "./DomainWebpageAdd.vue?vue&type=template&id=0f9db88e&scoped=true&"
import script from "./DomainWebpageAdd.vue?vue&type=script&lang=js&"
export * from "./DomainWebpageAdd.vue?vue&type=script&lang=js&"
import style0 from "./DomainWebpageAdd.vue?vue&type=style&index=0&id=0f9db88e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9db88e",
  null
  
)

export default component.exports